angular.module('unica_hotel.hotel_services')

.factory('HotelCreateService', function($http, getBaseApiURL) {

	var hotelCreateService = {};

	hotelCreateService.create = function(hotelData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/hotel/create',
			data: hotelData
		}).then(function(result) {

			if ( result ) {
				return result.data.hotel;
			}

		});
	};

	return hotelCreateService;

});